// Single source of truth for whether a vehicle counts as "leasable".
// motiondata's `leasing_moeglich` is unreliable upstream, so we derive
// leasability from VAT deductibility plus first-registration recency.
// Used by both the car-list badge and the search filter; keep callers
// importing from here so the two stay aligned.

const LEASABLE_WINDOW_MONTHS = 60;

/**
 * Cutoff timestamp (ms since epoch). A vehicle's `first_registration`
 * must be more recent than this to count as leasable.
 * Computed via Date#setMonth so leap months and varying month lengths
 * are handled correctly, unlike `60 * 30 * 24 * 60 * 60 * 1000`.
 */
export function leasableSinceMs(now: Date = new Date()): number {
  const cutoff = new Date(now);
  cutoff.setMonth(cutoff.getMonth() - LEASABLE_WINDOW_MONTHS);
  return cutoff.getTime();
}

export function isLeasable(
  vehicle: { vat_deductible?: boolean | null; first_registration?: string | null },
  now: Date = new Date()
): boolean {
  if (!vehicle.vat_deductible || !vehicle.first_registration) return false;
  return new Date(vehicle.first_registration).getTime() > leasableSinceMs(now);
}
